import { render, staticRenderFns } from "./BaseArrayCheckbox.vue?vue&type=template&id=3622926b&scoped=true&lang=pug"
import script from "./BaseArrayCheckbox.vue?vue&type=script&lang=ts"
export * from "./BaseArrayCheckbox.vue?vue&type=script&lang=ts"
import style0 from "./BaseArrayCheckbox.vue?vue&type=style&index=0&id=3622926b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3622926b",
  null
  
)

export default component.exports